import { createColDef } from '@fortem-monorepo/react-ag'

import { CurrencyIdCellEditor } from '@/ag-grid/columns/currency-id/cell-editor'
import { CurrencyIdCellRenderer } from '@/ag-grid/columns/currency-id/renderer'

export const currency_id = createColDef({
  field: 'currency_id',
  headerName: 'Currency',
  cellRenderer: CurrencyIdCellRenderer,
  cellEditor: CurrencyIdCellEditor,
  width: 100,
})
